module.exports = __webpack_public_path__ + "img/image23.cde9b12c.png";